
import moment from 'moment-timezone'
import HoldTimer from './HoldTimer.vue'

export default {
    components: { HoldTimer },
    props: {
        // Eastern-only wizard: render the held slot in the zone it was picked in.
        timezone: { type: String, default: 'America/New_York' },
        method: { type: String, default: null }, // 'phone' | 'video' | 'email'
        date: { type: String, default: null }, // ISO date or datetime
        time: { type: String, default: null }, // ISO datetime
        heldUntil: { type: Number, default: null }, // epoch ms
    },
    computed: {
        isEmail () { return this.method === 'email' || this.method === 'survey' },
        show () {
            if (this.isEmail) return true
            return !!(this.date && this.time)
        },
        whenLabel () {
            if (!this.time) return ''
            return moment.tz(this.time, this.timezone).format('dddd, MMMM D [at] h:mm A')
        },
        methodLabel () {
            return this.method === 'video' ? 'Video' : 'Phone'
        },
    },
}
